import React, { useState, useEffect } from 'react';

import './styles.css';

import trainingsServices from '../../../services/academy/trainingsServices';

import { months } from '../../../functions/formatDate';
import capitalize from '../../../functions/capitalize';
import compare from '../../../functions/compare';

import MainView from '../../../components/MainView';
import NavHistory from '../../../components/NavHistory';
import ActivityIndicator from '../../../components/ActivityIndicator';
import TrainingsGroup from './TrainingsGroup';
import PopupCallList from '../Class/ClassCallListsCard/PopupCallList';
import PopupNewCallList from '../Class/ClassCallListsCard/PopupNewCallList';
import PopupCheckout from './PopupCheckout';

export default function Trainings(props) {
    const dateNow = new Date();
    const [time, setTime] = useState(`${String(dateNow.getHours()).padStart(2, '0')}:${String(dateNow.getMinutes()).padStart(2, '0')}`);
    const [date, setDate] = useState(`${String(dateNow.getDate()).padStart(2, '0')} de ${capitalize(months[dateNow.getMonth()])}`);
    const [todayTrainings, setTodayTrainings] = useState([]);
    const [tomorrowTrainings, setTomorrowTrainings] = useState([]);
    const [popupCallListVisible, setPopupCallListVisible] = useState(false);
    const [popupNewCallListVisible, setPopupNewCallListVisible] = useState(false);
    const [popupCheckoutVisible, setPopupCheckoutVisible] = useState(false);
    const [popupNewCallListData, setPopupNewCallListData] = useState(null);
    const [popupCallListData, setPopupCallListData] = useState(null);
    const [fetching, setFetching] = useState(true);

    useEffect((time) => {
        updateTime();
        updateDate();
        readAcademyTrainings();
        setInterval(() => {
            updateTime();
            if (time === '00:00') {
                updateDate();
            }
        }, 1000);
    }, []);

    async function readAcademyTrainings() {
        const dateNow = new Date();
        const todayDate = `${dateNow.getFullYear()}-${String(dateNow.getMonth() + 1).padStart(2, '0')}-${String(dateNow.getDate()).padStart(2, '0')}`;
         
        dateNow.setDate(dateNow.getDate() + 1);
        const tomorrowDate = `${dateNow.getFullYear()}-${String(dateNow.getMonth() + 1).padStart(2, '0')}-${String(dateNow.getDate()).padStart(2, '0')}`;

        let response = await trainingsServices.getAcademyTrainings(todayDate);
        if (response.status === 200) {
            setTodayTrainings(response.data.sort((a, b) => compare(`${a.hora_inicio}${a.hora_fim}`, `${b.hora_inicio}${b.hora_fim}`)));
        } else
            alert("Erro ao ler treinos de hoje, tente novamente!");

        response = await trainingsServices.getAcademyTrainings(tomorrowDate);
        if (response.status === 200) {
            setTomorrowTrainings(response.data.sort((a, b) => compare(`${a.hora_inicio}${a.hora_fim}`, `${b.hora_inicio}${b.hora_fim}`)));
        } else
            alert("Erro ao ler treinos de amanhã, tente novamente!");

        setFetching(false);
    }
    
    async function readTodaysTrainings() {
        const dateNow = new Date();
        const todayDate = `${dateNow.getFullYear()}-${String(dateNow.getMonth() + 1).padStart(2, '0')}-${String(dateNow.getDate()).padStart(2, '0')}`;
         
        let response = await trainingsServices.getAcademyTrainings(todayDate);
        if (response.status === 200) {
            setTodayTrainings(response.data.sort((a, b) => compare(`${a.hora_inicio}${a.hora_fim}`, `${b.hora_inicio}${b.hora_fim}`)));
        } else
            alert("Erro ao ler treinos de hoje, tente novamente!");
    }

    function updateTime() {
        const dateNow = new Date();
        setTime(`${String(dateNow.getHours()).padStart(2, '0')}:${String(dateNow.getMinutes()).padStart(2, '0')}`);
    }

    function updateDate() {
        const dateNow = new Date();
        setDate(`${String(dateNow.getDate()).padStart(2, '0')} de ${capitalize(months[dateNow.getMonth()])}`);
    }

    function showPopupCallList(data) {
        setPopupCallListData(data);
        setPopupCallListVisible(true);
    }

    function showPopupNewCallList(data) {
        setPopupNewCallListData(data);
        setPopupNewCallListVisible(true);
    }

    function showPopupCheckout(data) {
        setPopupCallListData(data);
        setPopupCheckoutVisible(true);
    }

    return (
        <MainView currentPage='trainings' coachMenu={props.coachMode}>
            <NavHistory navPages={['Treinos']} />

            <div className='trainings-page-date-time'>
                <h3>{time}</h3>
                <h4>{date}</h4>
            </div>

            {
                !fetching ?
                    <>
                        <ul className='trainings-page-list'>
                            <TrainingsGroup
                                dataRef='hoje'
                                trainingsData={todayTrainings}
                                showPopupCallList={showPopupCallList}
                                showPopupNewCallList={showPopupNewCallList}
                                showPopupCheckout={showPopupCheckout}
                            />
                            <TrainingsGroup
                                dataRef='amanhã'
                                hideCallListOptions
                                trainingsData={tomorrowTrainings}
                                showPopupCallList={showPopupCallList}
                                showPopupNewCallList={showPopupNewCallList}
                                showPopupCheckout={showPopupCheckout}
                            />
                        </ul>
                        
                        <PopupNewCallList
                            data={popupNewCallListData}
                            onCreate={readTodaysTrainings}
                            visibility={popupNewCallListVisible}
                            setVisibility={setPopupNewCallListVisible}
                        />
                        <PopupCallList
                            data={popupCallListData}
                            onUpdate={readTodaysTrainings}
                            visibility={popupCallListVisible}
                            setVisibility={setPopupCallListVisible}
                        />
                        <PopupCheckout
                            data={popupCallListData}
                            onUpdate={readTodaysTrainings}
                            visibility={popupCheckoutVisible}
                            setVisibility={setPopupCheckoutVisible}
                        />
                    </>
                    : <ActivityIndicator />
            }

        </MainView>
    )
}